import Vue from 'vue';
import VueMask from 'v-mask';
import './plugins/element-ui';
import './scss/main.scss';
import App from './App.vue';
import router from './router';
import store from './store';
import { date, dateTime } from './filters/date';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Vue.config.productionTip = false;

Vue.filter('date', date);
Vue.filter('dateTime', dateTime);
Vue.use(VueMask);

// if (process.env.VUE_APP_SENTRY_ENVIROMENT !== 'local') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DNS,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    environment: process.env.VUE_APP_SENTRY_ENVIROMENT || 'local'
  });
  // }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
